// ARQUIVO ATUALIZADO E CORRIGIDO
import React, { useState, useEffect } from 'react';
import Modal from '../ui/Modal';
import Button from '../ui/Button';
import CustomDatePicker from '../ui/CustomDatePicker';
import { getPriorityButtonClass } from '../../utils/helpers';
import Portal from '../ui/Portal';
import Backdrop from '../ui/Backdrop';

const NewTaskModal = ({ isOpen, onClose, onSave, projects = [], clients = [], initialStatus, initialProjectId = null }) => {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [priority, setPriority] = useState('Média');
    const [deadline, setDeadline] = useState('');
    const [selectedProjectId, setSelectedProjectId] = useState('');
    const [selectedClientName, setSelectedClientName] = useState('');
    const [status, setStatus] = useState(initialStatus || 'A Fazer');
    const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setStatus(initialStatus || 'A Fazer');
            // --- INÍCIO DA ALTERAÇÃO ---
            if (initialProjectId) {
                setSelectedProjectId(initialProjectId);
                const project = projects.find(p => p.id === initialProjectId);
                if (project && project.clientId) {
                    const client = clients.find(c => c.id === project.clientId);
                    if (client) {
                        setSelectedClientName(client.name);
                    }
                }
            }
            // --- FIM DA ALTERAÇÃO ---
        } else {
            // Reset state when closing
            setTitle('');
            setDescription('');
            setPriority('Média');
            setDeadline('');
            setSelectedProjectId('');
            setSelectedClientName('');
        }
    }, [isOpen, initialStatus, initialProjectId, projects, clients]);

    const handleSave = () => {
        if (title.trim()) {
            onSave({ title, description, priority, deadline, projectId: selectedProjectId, client: selectedClientName, status });
            onClose();
        }
    };
    
    const handleDateSelect = (date) => {
        setDeadline(date);
        setIsDatePickerOpen(false);
    };

    const footerButtons = (
        <>
            <Button onClick={onClose} variant="minimal">Cancelar</Button>
            <Button onClick={handleSave} disabled={!title.trim()} className="!bg-indigo-500">Criar Tarefa</Button>
        </>
    );

    const priorities = ['Baixa', 'Média', 'Alta'];
    const selectClasses = "w-full p-2.5 text-white bg-white/10 rounded-lg border border-white/30 focus:outline-none focus:ring-2 focus:ring-indigo-400/80 transition-all duration-200 appearance-none";

    return (
        <>
            <Modal
                isOpen={isOpen}
                onClose={onClose}
                title="Criar Nova Tarefa"
                footer={footerButtons}
                maxWidth="max-w-3xl"
                closeOnClickOutside={!isDatePickerOpen}
            >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
                    <div className="flex flex-col gap-4">
                        <div>
                            <label className="block text-sm font-medium text-slate-300 mb-1">Título *</label>
                            <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && handleSave()} placeholder="Qual é a tarefa principal?" className="w-full p-3 text-white bg-white/10 rounded-lg border border-white/30 focus:outline-none focus:ring-2 focus:ring-indigo-400/80" autoFocus />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-slate-300 mb-1">Descrição</label>
                            <textarea value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Adicione mais detalhes..." rows="5" className="w-full p-3 text-white bg-white/10 rounded-lg border border-white/30 focus:outline-none focus:ring-2 focus:ring-indigo-400/80 resize-none" />
                        </div>
                    </div>
                    <div className="flex flex-col gap-4">
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <label className="block text-sm font-medium text-slate-300 mb-1">Projeto</label>
                                <select value={selectedProjectId} onChange={(e) => setSelectedProjectId(e.target.value)} className={selectClasses}>
                                    <option value="">Nenhum</option>
                                    {projects.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
                                </select>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-slate-300 mb-1">Cliente</label>
                                <select value={selectedClientName} onChange={(e) => setSelectedClientName(e.target.value)} className={selectClasses}>
                                    <option value="">Nenhum</option>
                                    {clients.map(c => <option key={c.id} value={c.name}>{c.name}</option>)}
                                </select>
                            </div>
                        </div>
                        <div>
                             <label className="block text-sm font-medium text-slate-300 mb-2">Prioridade</label>
                             <div className="flex gap-2">
                                {priorities.map((p) => (
                                    <button key={p} onClick={() => setPriority(p)} className={`flex-1 py-2 text-sm rounded-md border transition-all ${priority === p ? getPriorityButtonClass(p) : 'bg-white/10 border-white/20 text-slate-300 hover:bg-white/20'}`}>
                                        {p}
                                    </button>
                                ))}
                             </div>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-slate-300 mb-2">Prazo</label>
                            <button onClick={() => setIsDatePickerOpen(true)} className="w-full p-2.5 text-left text-white bg-white/10 rounded-lg border border-white/30 cursor-pointer hover:bg-white/20 transition-colors">
                                {deadline ? new Date(deadline).toLocaleDateString('pt-BR', { timeZone: 'UTC' }) : 'Selecione uma data'}
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
            
            {isDatePickerOpen && (
                <Portal>
                    <Backdrop onClick={() => setIsDatePickerOpen(false)} />
                    <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[60]">
                        <CustomDatePicker 
                            value={deadline} 
                            onChange={handleDateSelect} 
                        />
                    </div>
                </Portal>
            )}
        </>
    );
};

export default NewTaskModal;